import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description: 'The department impacted by a change impact',
    name: 'Change Impact Department',
    partialId: PartialId.Standard.create('change_impact_department'),
  },
  type: core.quiver.Resource.Type.DmsEnum,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnum>
